var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("activator",null,{"on":{ click: _vm.clickUploadButton }}),_c('input',{ref:"uploader",staticClass:"d-none",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event.target.files)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }